<div
  *renderingPermissionDirective="[
    'FirmwareAdmin',
    'FirmwareReader',
    'FirmwareWriter',
    'ModuleUpdateAdmin',
    'ModuleUpdateReader',
    'ModuleUpdateWriter',
  ]"
  class="releases">
  <div class="releases__content">
    <div class="releases__grid-title">
      <span class="lx-section-title">releases</span>
    </div>

    <dcc-release-query
      class="releases-metrics"
      [queryParams]="query"
      [total]="releases.length"
      (updateQuery)="onQuery($event)"></dcc-release-query>

    <div class="releases-create">
      <button
        class="releases__button-container lx-btn-small lx-btn-primary"
        (click)="onCreateClick()">
        Create Release
      </button>
    </div>
    <div class="releases__data">
      <ag-grid-angular
        class="ag-theme-alpine ag-grid-sticky-header"
        domLayout="autoHeight"
        style="width: 100%; height: 100%"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [enableCellTextSelection]="true"
        [ensureDomOrder]="true"
        [rowSelection]="'single'"
        [suppressRowHoverHighlight]="true"
        [tooltipHideDelay]="tooltipHideDelay"
        [tooltipShowDelay]="tooltipShowDelay"
        (gridReady)="onGridReady($event)"></ag-grid-angular>
    </div>

    <dcc-footer-items-dropdown
      class="releases__pagination_container__count-select"
      [pageSize]="pageSize"
      (changedPageSize)="
        onPageSizeSelected($event)
      "></dcc-footer-items-dropdown>

    <paginator
      class="releases__pagination_container__page-select"
      [currentPageNumber]="currentPage"
      [endOfSet]="endOfSet"
      [pageNumbers]="numberOfPages"
      (selectedPage)="onPageSelection($event)"></paginator>
  </div>
</div>
